import MapSettingsContextInterface from './MapSettingsContextInterface'

export const initialContextState: MapSettingsContextInterface = {
  map: undefined,
  setMap: () => {
    console.log('setMap')
  },
  selectedCollections: [],
  setSelectedCollections: (selectedCollections: any[]) => {
    console.log('selectedCollections')
  },
  activeCounties: new Map(),
  setActiveCounties: () => {
    console.log('setActiveCounties')
  },
  selectedVehicleHistory: undefined,
  setSelectedVehicleHistory: () => {
    console.log('setSelectedVehicleHistory')
  },
  followedVehicleId: undefined,
  setFollowedVehicleId: () => {
    console.log('setFollowedVehicleId')
  },
  selectedVehicleId: undefined,
  setSelectedVehicleId: () => {
    console.log('setSelectedVehicleId')
  },
  directionsOpen: false,
  setDirectionsOpen: () => {
    console.log('setDirectionsOpen')
  },
}
